import { Modal, Form, Input, Switch } from "antd";
import { useEffect, useState } from "react";
import { updateKorisnik } from "../services/korisnik.service"; 

const EditEmployeeModal = ({ open, onCancel, onUpdated, initialValues }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [open, initialValues]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        korisnickoIme: initialValues.korisnickoIme,
        tipKorisnika: initialValues.tipKorisnika,
        role: initialValues.role,
        privremenaLozinka: false,
        lozinka: initialValues.lozinka,
      };
      setSubmitting(true);
      await updateKorisnik(initialValues.korisnickoIme, payload);
      alert("Korisnik uspješno ažuriran.");
      form.resetFields();
      onUpdated();  
    } catch (err) {
      alert("Greška pri ažuriranju korisnika.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Ažuriraj zaposlenog"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleOk}
      confirmLoading={submitting}
      okText="Sačuvaj"
      cancelText="Otkaži"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="ime" label="Ime" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="prezime" label="Prezime" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ type: "email", required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="aktivan" label="Aktivan" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditEmployeeModal;
